var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Box, MenuItem, Paper, TextField, Typography, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { AdminLayout } from "frontend/src/pages/layouts";
import { useMailSettings, useUpdateMailSettings, } from "frontend/src/domain/mail-settings";
import { ButtonLoader } from "frontend/src/ui/button-loader";
var defaultSettings = {
    mailHost: "",
    mailPort: "587",
    mailEncryption: "tls",
    mailUsername: "",
    mailPassword: "",
    mailFromAddress: "",
    mailFromName: "Imstream",
    clientAccessMailSubject: "Доступ в личный кабинет Imstream",
    clientAccessMailTemplate: "Доступ в личный кабинет Imstream\n\nЛогин: {login}\nПароль: {password}",
    passwordResetMailSubject: "Восстановление пароля Imstream",
    passwordResetMailTemplate: "Для вашего кабинета Imstream создан новый пароль.\n\nЛогин: {login}\nПароль: {password}",
};
var Page = function () {
    var settings = useMailSettings();
    var update = useUpdateMailSettings();
    var _a = React.useState(defaultSettings), form = _a[0], setForm = _a[1];
    var _b = React.useState(false), isDirty = _b[0], setDirty = _b[1];
    React.useEffect(function () {
        if (settings.data && !isDirty) {
            setForm(settings.data);
        }
    }, [settings.data, isDirty]);
    var change = function (key) {
        return function (evt) {
            var value = evt.target.value;
            setDirty(true);
            setForm(function (current) {
                var _a;
                return (__assign(__assign({}, current), (_a = {}, _a[key] = value, _a)));
            });
        };
    };
    var submit = function (evt) {
        evt.preventDefault();
        update.mutate(form, {
            onSuccess: function (savedSettings) {
                setForm(savedSettings);
                setDirty(false);
            },
        });
    };
    return (React.createElement(Paper, null,
        React.createElement(Box, { p: 2 },
            React.createElement(Typography, { variant: "h6" }, "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u043E\u0447\u0442\u044B"),
            settings.isLoading ? (React.createElement(Box, { mt: 2 },
                React.createElement(Skeleton, { height: 48 }),
                React.createElement(Skeleton, { height: 48 }),
                React.createElement(Skeleton, { height: 48 }))) : (React.createElement("form", { onSubmit: submit },
                React.createElement(Box, { mt: 2 },
                    React.createElement(TextField, { label: "Сервер SMTP/IMAP", value: form.mailHost, onChange: change("mailHost"), fullWidth: true })),
                React.createElement(Box, { mt: 1, display: "flex", gridGap: 8 },
                    React.createElement(TextField, { label: "Порт", value: form.mailPort, onChange: change("mailPort"), fullWidth: true }),
                    React.createElement(TextField, { select: true, label: "Шифрование", value: form.mailEncryption, onChange: change("mailEncryption"), fullWidth: true },
                        React.createElement(MenuItem, { value: "tls" }, "TLS"),
                        React.createElement(MenuItem, { value: "ssl" }, "SSL"),
                        React.createElement(MenuItem, { value: "none" }, "\u041D\u0435\u0442"))),
                React.createElement(Box, { mt: 1, display: "flex", gridGap: 8 },
                    React.createElement(TextField, { label: "Логин почты", value: form.mailUsername, onChange: change("mailUsername"), fullWidth: true }),
                    React.createElement(TextField, { label: "Пароль почты", type: "password", value: form.mailPassword, onChange: change("mailPassword"), fullWidth: true })),
                React.createElement(Box, { mt: 1, display: "flex", gridGap: 8 },
                    React.createElement(TextField, { label: "Почта отправителя", value: form.mailFromAddress, onChange: change("mailFromAddress"), fullWidth: true }),
                    React.createElement(TextField, { label: "Имя отправителя", value: form.mailFromName, onChange: change("mailFromName"), fullWidth: true })),
                React.createElement(Box, { mt: 2 },
                    React.createElement(Typography, { variant: "subtitle1" }, "\u041F\u0438\u0441\u044C\u043C\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430")),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { label: "Тема письма", value: form.clientAccessMailSubject, onChange: change("clientAccessMailSubject"), fullWidth: true })),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { label: "Шаблон письма", value: form.clientAccessMailTemplate, onChange: change("clientAccessMailTemplate"), multiline: true, rows: 8, helperText: "Доступные переменные: {login}, {password}", fullWidth: true })),
                React.createElement(Box, { mt: 2 },
                    React.createElement(Typography, { variant: "subtitle1" }, "\u041F\u0438\u0441\u044C\u043C\u043E \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u043E\u043B\u044F")),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { label: "Тема письма", value: form.passwordResetMailSubject, onChange: change("passwordResetMailSubject"), fullWidth: true })),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { label: "Шаблон письма", value: form.passwordResetMailTemplate, onChange: change("passwordResetMailTemplate"), multiline: true, rows: 6, helperText: "Доступные переменные: {login}, {password}", fullWidth: true })),
                React.createElement(Box, { mt: 2, display: "flex", justifyContent: "flex-end" },
                    React.createElement(ButtonLoader, { type: "submit", color: "primary", variant: "contained", isLoading: update.isLoading }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))))));
};
export var SettingsPage = function () { return (React.createElement(AdminLayout, null,
    React.createElement(Page, null))); };
